import React from 'react';

interface IUnderlineIconProps {
  style?: any;
}

export const UnderlineIcon:React.FC<IUnderlineIconProps> = (props: IUnderlineIconProps) => {
  return (
    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 15.75H13.5V18H0V15.75ZM9 0V1.12556C9.62156 1.12556 10.125 1.629 10.125 2.25056V9.00056C10.125 10.8641 8.613 12.3756 6.75 12.3756C4.88475 12.3756 3.375 10.8641 3.375 9.00056V2.25056C3.375 1.62956 3.87844 1.12556 4.5 1.12556V0H0V1.12556C0.621562 1.12556 1.125 1.629 1.125 2.25056V9.00056C1.125 12.1067 3.64331 14.625 6.75 14.625C9.85669 14.625 12.375 12.1067 12.375 9.00056V2.25056C12.375 1.62956 12.8784 1.12556 13.5 1.12556V0H9Z" fill="#CCCCCC"/>
    </svg>
  )
}